import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_stmt_account_run_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  batch_running_no: fromDatatype.VarcharDatatypeInterface;
  run_type: fromDatatype.VarcharDatatypeInterface;
  run_status: fromDatatype.VarcharDatatypeInterface;
  statement_type: fromDatatype.VarcharDatatypeInterface;
  printable_format_hdr_guid: fromDatatype.GuidDataFieldInterface;
  printable_file_guid: fromDatatype.GuidDataFieldInterface;
  stmt_start_date: fromDatatype.TimestampTzDatatypeInterface;
  stmt_end_date: fromDatatype.TimestampTzDatatypeInterface;
  soa_settings_json: fromDatatype.JsonDatatypeInterface;
  companies_json: fromDatatype.JsonDatatypeInterface;
  recipient_emails: fromDatatype.JsonDatatypeInterface;
  customer_categories: fromDatatype.JsonDatatypeInterface;
  run_by_guid: fromDatatype.GuidDataFieldInterface;
  run_start_date: fromDatatype.TimestampTzDatatypeInterface;
  run_end_date: fromDatatype.TimestampTzDatatypeInterface;
  run_count_total: fromDatatype.BigIntegerDatatypeInterface;
  run_count_completed: boolean;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
}

export class bl_fi_stmt_account_run_hdr_RowClass
  implements bl_fi_stmt_account_run_hdr_RowInterface
{
    guid: fromDatatype.GuidDataFieldInterface;
    batch_running_no: fromDatatype.VarcharDatatypeInterface;
    run_type: fromDatatype.VarcharDatatypeInterface;
    run_status: fromDatatype.VarcharDatatypeInterface;
    statement_type: fromDatatype.VarcharDatatypeInterface;
    printable_format_hdr_guid: fromDatatype.GuidDataFieldInterface;
    printable_file_guid: fromDatatype.GuidDataFieldInterface;
    stmt_start_date: fromDatatype.TimestampTzDatatypeInterface;
    stmt_end_date: fromDatatype.TimestampTzDatatypeInterface;
    soa_settings_json: fromDatatype.JsonDatatypeInterface;
    companies_json: fromDatatype.JsonDatatypeInterface;
    recipient_emails: fromDatatype.JsonDatatypeInterface;
    customer_categories: fromDatatype.JsonDatatypeInterface;
    run_by_guid: fromDatatype.GuidDataFieldInterface;
    run_start_date: fromDatatype.TimestampTzDatatypeInterface;
    run_end_date: fromDatatype.TimestampTzDatatypeInterface;
    run_count_total: fromDatatype.BigIntegerDatatypeInterface;
    run_count_completed: boolean;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
}
